import { Stack, Dialog } from '@mui/material';

import { Header } from '@app/sections/header';
import { Card404, Scrollbar } from '@app/components';
import { Strings } from '@app/constants';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  document?: string;
  aadharFront?: string;
  aadharBack?: string;
  panFront?: string;
  panBack?: string;
}

const ViewDocument = ({
  open,
  onClose,
  document,
  aadharBack,
  aadharFront,
  panBack,
  panFront,
}: Props) => {
  const hasImages = (() => {
    if (document === 'aadhar') return aadharFront ?? aadharBack;
    if (document === 'pan') return panFront ?? panBack;
    return false;
  })();
  return (
    <Dialog open={open} fullWidth>
      <Header
        variant="dialog"
        title={document === 'aadhar' ? Strings.page_title.aadharCard : Strings.page_title.panCard}
        onClose={onClose}
      />
      <Scrollbar>
        <Stack
          sx={{
            margin: 4.5,
            borderRadius: 1,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {hasImages ? (
            <>
              {document === 'aadhar' && (
                <>
                  {aadharFront && (
                    <img
                      src={aadharFront}
                      style={{ objectFit: 'contain', height: 'auto' }}
                      alt="Aadhar Front"
                    />
                  )}
                  {aadharBack && (
                    <img
                      src={aadharBack}
                      style={{ objectFit: 'contain', height: 'auto' }}
                      alt="Aadhar Back"
                    />
                  )}
                </>
              )}
              {document === 'pan' && (
                <>
                  {panFront && (
                    <img
                      src={panFront}
                      style={{ objectFit: 'contain', height: 'auto' }}
                      alt="PAN Front"
                    />
                  )}
                  {panBack && (
                    <img
                      src={panBack}
                      style={{ objectFit: 'contain', height: 'auto' }}
                      alt="PAN Back"
                    />
                  )}
                </>
              )}
            </>
          ) : (
            <Card404 height={240} />
          )}
        </Stack>
      </Scrollbar>
    </Dialog>
  );
};

export { ViewDocument };
